import React, { useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import axiosHelper from '../../../axiosHelper';
import { APIUSEROLD } from '../../../config/constants';
import { apiErrors } from '../../../helper';

const ApplicationTrackerDatesReport = () => {
  const [embedConfig, setEmbedConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmbedConfig = () => {
      axiosHelper.get(`${APIUSEROLD.GetPowerBiReport}?type=applicationtrackerdates`)
        .then(response => {
          console.log('response: ', response);

          if (response.status !== 200) {
            throw new Error('Failed to fetch the report details');
          }

          const { ReportId, EmbedUrl, EmbedToken } = response.data.Data;

          setEmbedConfig({
            type: 'report',
            id: ReportId,
            embedUrl: EmbedUrl,
            accessToken: EmbedToken.Token,
            tokenType: models.TokenType.Embed,
            settings: {
              panes: {
                filters: {
                  visible: false
                },
                pageNavigation: {
                  visible: false
                }
              }
            }
          });

          setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching embed config:', error);
          setLoading(false);
          if (error.response.status === 401) {
            apiErrors(error)
          }
          
        });
    };

    fetchEmbedConfig();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="embed-container hl-bi-iframe" style={{ height: '600px', width: '100%' }}>
      <PowerBIEmbed
        embedConfig={embedConfig}
        eventHandlers={
          new Map([
            ['loaded', () => console.log('Report loaded')],
            ['rendered', () => console.log('Report rendered')],
            ['error', (event) => console.log('Error:', event.detail)],
          ])
        }
        cssClassName={'embed-container'}  // Apply class name here
        getEmbeddedComponent={(embeddedReport) => {
          console.log('Embedded report:', embeddedReport);
        }}
      />
    </div>
  );
};

export default ApplicationTrackerDatesReport;
